import React, { useState } from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Button,
} from "@mui/material";
import Loader from "../../../component/loading-screen/Loader";
import NoDataView from "../../../component/NoDataView";
import { CustomerUser } from "../../customers/CustomerUser";
import TaskBoard from "../TaskBoard";
import ProjectDashboard from "../ProjectDashboard";

const PaginateCardBiggBraing = ({
  columns = [],
  list = [],
  totalRows = 0,
  handlePerRowsChange,
  handlePageChange,
  progressPending = false,
  per_page = 10,
  onRowClicked,
  selectableRows = false,
  onSelectedRowsChange,
  pagename,
  setLastPage,
  refresh
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(per_page);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (handlePageChange) handlePageChange(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log("disjgdsuhv",event.target.value);
    
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    if (handlePerRowsChange){
       handlePerRowsChange(parseInt(event.target.value));
       setLastPage(rowsPerPage)
    }
  };

  const getStatusButtonColor = (status) => {
    switch (status) {
      case "Active":
        return { backgroundColor: "green", color: "white" };
      case "Inactive":
        return { backgroundColor: "red", color: "white" };
      default:
        return { backgroundColor: "gray", color: "white" };
    }
  };

  return (
    <Grid sx={{  position: "relative" }}>
      <Loader loading={progressPending} circleBlue />
  {pagename==="customer"&&
      <CustomerUser refresh={refresh} users={list}/>
  }
  {pagename==="project"&&
      <ProjectDashboard refresh={refresh} data={list}/>
  }

      <TablePagination
        rowsPerPageOptions={[5, 10, 20,25,]}
        component="div"
        count={totalRows || list.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
};

export default PaginateCardBiggBraing;
